import React from "react"
import useParseHTMLString from "../hooks/useParseHTMLString"

const Richtext = ({ text }) => (
  <React.Fragment>{useParseHTMLString(text)}</React.Fragment>
)

export default Richtext
